package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.replacePathParams

/**
 * `GET /api/v1/areas`: the areas having data for the added occupations (all occupations when none are added).
 *
 * The year bounds are optional, as the API treats them: without them the API covers the same latest five years as
 * `GET /api/v1/chart` without them, so the areas listed are the ones the chart has data for.
 */
class WMAreasWithDataRequestBuilder: WMOccupationsAndYearBoundRequestBuilder<WMAreasWithDataRequestBuilder>(yearBoundsRequired = false) {

    override fun build(): FSRequest<Nothing> {
        replacePathParams("api", "v1", "areas")
        acceptJson()
        method(FSRequest.Method.Get)
        return super.build()
    }

    override fun self(): WMAreasWithDataRequestBuilder = this
}
